export function updateEventsState(state, payload) {
  state[payload.state] = payload.data;
}
